import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  uploadFileToS3,
  preSignedUrl,
  postEmailTemplate,
  fetchEmailMetaData
} from '../actions/sessionActions';
import { Select, Button, Row, Col, message, Input } from 'antd';
const { Option } = Select;
import { getBase64 } from '../utils/assetUtils';

export class CreateEmailTemplate extends Component {
  state = {
    formInput: {
      name: null,
      notification: null,
      file: {}
    },
    isSubmitting: false
  };
  htmlTemplate = React.createRef();
  componentWillMount = () => {
    this.props.fetchEmailMetaData();
  };

  handleInputChange = e => {
    const { formInput } = this.state;
    formInput[e.target.name] = e.target.value;
    this.setState({ formInput });
  };

  handleChange = (key, value) => {
    const { formInput } = this.state;
    formInput[key] = value;
    this.setState({ formInput });
  };

  handleRadioChange = e => {
    const { formInput } = this.state;
    formInput[e.target.name] = e.target.value;
    formInput.file = {};
    this.htmlTemplate.current.value = null;
    this.setState({ formInput });
  };

  fileSelect = e => {
    const { formInput } = this.state;
    formInput.file = e.target.files[0];
    this.setState({ formInput });
  };

  handleSubmit = () => {
    const { emailTemplate } = this.props;
    const { formInput } = this.state;
    if (!formInput.name) {
      return message.info('Please select label size');
    }
    if (!formInput.notification) {
      return message.info('Please select notification');
    }
    if (!formInput.file.name) {
      return message.info('Please select email template');
    }
    this.setState({ isSubmitting: true });
    let preUrl = `${emailTemplate.file.directory}${parseInt(
      new Date().getTime()
    )}.html`;
    const obj = {
      name: formInput.name,
      notification_event_id: formInput.notification,
      file_upload: preUrl
    };
    if (formInput.file.name) {
      getBase64(formInput.file, () => {
        this.props.preSignedUrl(preUrl).then(res => {
          if (res) {
            const { url, fields } = res;
            this.props
              .uploadFileToS3({ file: formInput.file, url, fields })
              .then(() => {
                this.props.postEmailTemplate(obj).then(resp => {
                  this.setState({ isSubmitting: false });
                  if (resp.meta.status === 200) {
                    this.handleReset();
                    message.success(
                      'Your data has been successfully submitted.'
                    );
                  } else {
                    message.error(res.meta.message);
                  }
                });
              });
          }
        });
      });
    }
  };

  handleReset = () => {
    this.setState({
      formInput: {
        name: null,
        notification: null,
        file: {}
      }
    });
    this.htmlTemplate.current.value = null;
  };

  render() {
    const { formInput } = this.state;
    const { emailTemplate } = this.props;

    return (
      <div>
        <h2>Set Email Template</h2>
        <Row className="margin-bottom-10">
          <Col span={3}>
            <span>Name:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Input
              name="name"
              className="ant-input"
              value={formInput.name}
              onChange={this.handleInputChange}
            />
          </Col>
          <Col span={3}>
            <span>Notification Event:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select notification event"
              value={formInput.notification}
              style={{ width: '100%' }}
              onChange={value => this.handleChange('notification', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {emailTemplate.notification.list.map((item, i) => (
                <Option key={i} value={item.notificationEventId}>
                  {item.notificationEvent}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Upload:</span>
          </Col>
          <Col span={21} className="margin-bottom-20">
            <input
              type="file"
              ref={this.htmlTemplate}
              name="htmlTemplate"
              accept=".html"
              onChange={this.fileSelect}
            />
          </Col>
          <Col span={24} className="margin-bottom-20">
            <Button
              type="primary"
              onClick={this.handleSubmit}
              loading={this.state.isSubmitting}
            >
              Submit
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={this.handleReset}
              disabled={this.state.isSubmitting}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

CreateEmailTemplate.propTypes = {
  emailTemplate: PropTypes.object,
  uploadFileToS3: PropTypes.func,
  preSignedUrl: PropTypes.func,
  postEmailTemplate: PropTypes.func,
  fetchEmailMetaData: PropTypes.func
};

CreateEmailTemplate.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  emailTemplate: state.session.emailTemplate
});

const mapDispatchToProps = dispatch => ({
  uploadFileToS3: query => dispatch(uploadFileToS3(query)),
  preSignedUrl: query => dispatch(preSignedUrl(query)),
  postEmailTemplate: query => dispatch(postEmailTemplate(query)),
  fetchEmailMetaData: () => dispatch(fetchEmailMetaData())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateEmailTemplate)
);
